import React from 'react';
import { connect } from 'react-redux';

import { Select } from 'redpoints-front-components/index';

import { allIncidentsFiltersSetBookmark } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersLabelSelected } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';
import { labelListSelector } from './constants';

const AllIncidentsFiltersLabel = ({
  allIncidentsFiltersSetBookmark,
  labelSelected,
}) => {
  const handleLabelSelection = value => {
    allIncidentsFiltersSetBookmark({ value: Boolean(value.includes('watch')) });
  };

  return (
    <Select
      allowClear
      aria-label="label-selector"
      data={labelListSelector}
      label={translate('reporting.allIncidentsInternal.filters.label')}
      mapping={{ key: 'id', value: 'value' }}
      mode="multiple"
      onChange={handleLabelSelection}
      placeholder={translate('common.all')}
      value={labelSelected || undefined}
    />
  );
};

const mapStateToProps = state => {
  return {
    labelSelected: getAllIncidentsFiltersLabelSelected(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetBookmark,
})(AllIncidentsFiltersLabel);
